<panel>
	<form>
		<h1>{{'company.search-company' | translate}}</h1>
		<section>
			<custom-input [label]="'search-company.keyword' | translate" inputType="text" [(value)]="companyQuery.keyword" />
			<custom-input [label]="'search-company.vat-number' | translate" inputType="text" [(value)]="companyQuery.vatNumber" />
			<custom-input [label]="'search-company.nace' | translate" inputType="number" [(value)]="companyQuery.nace" />
			<custom-input [label]="'search-company.business-name' | translate" inputType="text" [(value)]="companyQuery.businessName" />
			<custom-input [label]="'search-company.phone-number' | translate" inputType="text" [(value)]="companyQuery.phoneNumber" />
			@for (zipCode of companyQuery.zipCode; let i = $index; track i) {
			<div><custom-input [label]="'search-company.zip-code' | translate" inputType="text" [(value)]="companyQuery.zipCode[i]" /></div>
			<div>
				@if (i == companyQuery.zipCode.length -1) { <button [loader]="false" (click)="companyQuery.zipCode.push('')">{{ 'general.add' | translate }}</button> }
			</div>
			}
		</section>
		<section>
			<button confirm #searchButton (click)="searchCompany()">{{ 'general.search' | translate }}</button>
		</section>
	</form>
	@if (result) {
		<section scrollable>
			@for (company of result; track company) {
				<div><span>{{company.companyName}}</span></div>
				<div><a (click)="viewCompany(company);">Gå til virksomhed</a></div>
			}
		</section>
	}
</panel>
